import type { AssetsPermissionResponse, AssetsPermissionsApiResponse } from './types.tsx';

export const transformAssetsPermissionResponse = (
	response: AssetsPermissionsApiResponse,
	apiCallSuccess: boolean,
): AssetsPermissionResponse => {
	return {
		isAssetsAdmin: response.isAdmin,
		isLicensedAssetsUser: apiCallSuccess && response.hasAssetsAccess,
	};
};

export const getAssetsPermissionUrl = (workspaceId: string) => {
	return __SERVER__
		? '/api/v1/permissions/permitted'
		: `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/permissions/permitted`;
};
